// extracted by mini-css-extract-plugin
export default {"container":"Section3_container__nrPS8"};